import React from 'react';

const Projects = () => (
  <div>
    Projects
  </div>
);

export default Projects;
